import { LitElement, html, css, styleMap } from '@hh/global.js'

class HHScrollProgressBar extends LitElement {
  static properties = {
    containerSelector: {
      type: String,
      attribute: 'container-selector',
    },
    progressWidth: {
      type: Number,
    },
  }
  constructor() {
    super()

    window.addEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    const scroll = document.body.scrollTop || document.documentElement.scrollTop
    const height = document.querySelector(this.containerSelector).clientHeight
    const scrolled = (scroll / height) * 100
    this.progressWidth = scrolled
  }

  render() {
    return html`
      <div class="scroll-progress__container">
        <div
          class="scroll-progress__bar"
          style=${styleMap({
            width: `${this.progressWidth}%`,
          })}
        ></div>
      </div>
    `
  }

  static styles = css`
    .scroll-progress__container {
      width: 100%;
      height: 4px;
    }

    .scroll-progress__bar {
      height: 4px;
      background: var(--hh-color-day);
      width: 0%;
    }
  `
}

customElements.define('hh-scroll-progress-bar', HHScrollProgressBar)
